import { render, staticRenderFns } from "./DigitalSignageElements.vue?vue&type=template&id=133be0c1&"
import script from "./DigitalSignageElements.vue?vue&type=script&lang=js&"
export * from "./DigitalSignageElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports